import { tv } from './tailwind';

export const buttonVariants = tv({
  base: 'relative inline-flex cursor-pointer items-center justify-center rounded-xl py-1 px-5 transition-colors text-button h-12 gap-2',
  variants: {
    variant: {
      rebecca:
        'bg-rebecca text-white  hover:bg-rebecca-dark active:bg-rebecca disabled:bg-neural-01 disabled:text-neural-03',
      white: 'bg-white hover:bg-neural-01 disabled:text-neural-03',
      'white-error':
        'bg-white text-error hover:bg-neural-01 disabled:text-neural-03',
      secondary:
        'bg-neural-01 text-black hover:bg-neural-02 active:bg-neural-03 disabled:bg-neural-01 disabled:text-neural-03',
      ghost:
        'text-black hover:text-primary active:text-[#010A1B] disabled:text-neural-03',
      'ghost-primary':
        'text-primary hover:text-primary-medium active:text-primary-dark disabled:text-neural-03',
      'ghost-error':
        'text-error hover:text-error-dark active:text-error disabled:text-error-light',
      'error-outline':
        'text-error hover:text-error-dark border border-error hover:border-error-dark active:border-error active:text-error disabled:text-error-light disabled:border-error-light',
      'primary-outline':
        'text-primary hover:text-white active:text-white bg-transparent hover:bg-primary-medium active:bg-primary-dark border border-primary hover:border-primary-medium active:border-primary-dark disabled:text-neural-03 disabled:border-neural-01 disabled:bg-neural-01',
      primary:
        'bg-primary text-white hover:bg-primary-medium active:bg-primary-dark disabled:bg-neural-01 disabled:text-neural-03',
      error:
        'bg-error-subtle text-error hover:text-white active:text-white hover:bg-error active:bg-error-dark disabled:bg-neural-01 disabled:text-neural-02',
    },
    withIcon: {
      true: 'pl-4',
      false: '',
    },
  },
  defaultVariants: {
    variant: 'primary',
    withIcon: false,
  },
});

export const fieldVariants = tv({
  base: 'px-4 rounded-lg bg-neural-01 text-rebecca text-body placeholder:text-neural-04 border border-transparent hover:bg-primary-subtle focus:border-primary disabled:text-neural-03 disabled:pointer-events-none w-full peer appearance-none',
  variants: {
    variant: {
      medium: 'h-14',
      smaller: 'h-12',
    },
    labelVariant: {
      static: 'transition-colors py-1',
      floating: 'block transition-all py-2',
    },
    label: {
      true: 'pt-4',
    },
    error: {
      true: '!border-error',
    },
    icon: {
      true: 'pl-12',
      false: '',
    },
  },
  defaultVariants: {
    labelVariant: 'floating',
    variant: 'medium',
  },
});
